import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BASE_URI, config } from '../../app.config';

@Injectable()
export class ForgotPasswordService {

  /** specifying Base URL.*/
  public BASE_URL = BASE_URI.URL

  constructor(private http: HttpClient) { }

  requestResetPassword(data) {
    return this.http.post(`${this.BASE_URL}/forgotPassword`, data);
  };
};
